import { render, staticRenderFns } from "./addFeatureControl.vue.js?vue&type=template&id=b2c8ff6c&scoped=true!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./addFeatureControl.vue?vue&type=template&id=b2c8ff6c&scoped=true"
import script from "./addFeatureControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./addFeatureControl.vue?vue&type=script&lang=js"
export * from "./addFeatureControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./addFeatureControl.vue?vue&type=script&lang=js"
import style0 from "./addFeatureControl.vue.scss?vue&type=style&index=0&id=b2c8ff6c&prod&lang=scss&scoped=true!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./addFeatureControl.vue?vue&type=style&index=0&id=b2c8ff6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c8ff6c",
  null
  
)

export default component.exports